import { Caption1 } from '@ui/Typography'

import { Box } from '@shared/components/Box'

import { CampaignProgressBar } from './CampaignProgressBar'

export const TradingViewProgressBar: React.FC<{ monthlyTradedVolume: number }> = ({
  monthlyTradedVolume,
}) => {
  return (
    <Box flex direction='column' gap='x4' content='flex-end' align='flex-start' alignSelf='stretch'>
      <CampaignProgressBar monthlyTradedVolume={monthlyTradedVolume} />
      <Box flex align='center' alignSelf='stretch' position='relative'>
        <Box position='absolute' style={{ left: '1%' }}>
          <Caption1 color='text-med-em'>0</Caption1>
        </Box>
        <Box position='absolute' style={{ left: '25%' }}>
          <Caption1 color='text-med-em'>3</Caption1>
        </Box>
        <Box position='absolute' style={{ left: '41%' }}>
          <Caption1 color='text-med-em'>5</Caption1>
        </Box>
        <Box position='absolute' style={{ left: '96%' }}>
          <Caption1 color='text-med-em'>12</Caption1>
        </Box>
      </Box>
    </Box>
  )
}
